import { render, staticRenderFns } from "./events-settings.vue?vue&type=template&id=e0a39912"
import script from "./events-settings.vue?vue&type=script&lang=js"
export * from "./events-settings.vue?vue&type=script&lang=js"
import style0 from "./events-settings.vue?vue&type=style&index=0&id=e0a39912&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports